<template>
  <div class="alertInPage printhide hover" v-bind:style="{'display':display}">
    <div class="alert alert-primary" role="alert" v-if="type==='primary'">
      {{ $t(msg) }}
    </div>
    <div class="alert alert-secondary" role="alert" v-if="type==='secondary'">
      {{ $t(msg) }}
    </div>
    <div class="alert alert-success" role="alert" v-if="type==='success'">
      {{ $t(msg) }}
    </div>
    <div class="alert alert-danger" role="alert" v-if="type==='danger'">
      {{ $t(msg) }}
    </div>
    <div class="alert alert-warning" role="alert" v-if="type==='warning'">
      {{ $t(msg) }}
    </div>
    <div class="alert alert-info" role="alert" v-if="type==='info'">
      {{ $t(msg) }}
    </div>
    <div class="alert alert-light" role="alert" v-if="type==='light'">
      {{ $t(msg) }}
    </div>
    <div class="alert alert-dark" role="alert" v-if="type==='dark'">
      {{ $t(msg) }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AlertInPage',
    data(){
      return {
        display: "none"
//        , delayData: 4000
      }
    },
    mounted() {
//      if (typeof delay !== "undefined") {
//        this.delayData = delay;
//      }
    },
    props: {
      type: String, // primary secondary success danger warning info light dark
      msg: String,
//      delay: Number,
    },
    watch: {
      msg: function (newmsg, oldmsg) {
        console.log("AlertInPage - run")
        const modul = this;
        if (newmsg.length > 0) {
          modul.display = "block"
        } else {
          modul.display = "none"
        }
//        const stfn = function () {
//          modul.display = "none"
//        }
//        setTimeout(stfn, Number(modul.delayData));
      }
    },
    methods: {
      something(e){
        return e;
      },
    }

  };
</script>

<style>
  .alertInPage.hover {
    position: fixed;
    top: 25px;
    right: 100px;
    z-index: 10;
    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.7);
    border-radius: .25rem;
  }
  .alertInPage > div {
    margin-bottom: 0;
  }

</style>


